var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"mb-2 shadow p-3 mb-5 rounded-lg cursor",attrs:{"title":_vm.title,"img-alt":"Image","img-top":"","tag":"article"}},[_c('b-card-text')],1)}
var staticRenderFns = []

export { render, staticRenderFns }